import request from '@/utils/seftRequest';

export function addCustAddress(data) {
  return request('/ding/custService/addCustAddress', {
    method: 'POST',
    body: data,
  });
}

// 新装
export function newConnection(data) {
  return request('/ding/custService/newConnection', {
    method: 'POST',
    body: data,
  });
}

// 查询domain drm/ding/custService/qryBBVPNDomainBsnl
export function qryBBVPNDomain(domainName) {
  return request(`/ding/custService/qryBBVPNDomainBsnl?domainName=${domainName}`);
}
